import { service, handleResponse, handleError } from "./apiService";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default {
    comment(url = baseUrl + '/comment/') {
        return {
            fetchAll: async (showHidden, searchText, pageNo, pageSize) => service.get(url + '?showHidden=' + showHidden
                + '&searchText=' + searchText 
                + '&pageNo=' + pageNo 
                + '&pageSize=' + pageSize),
            fetchById: async id => service.get(url + id),
            create: async newRecord => service.post(url, newRecord),
            update: async (id, updateRecord) => service.post(url + 'update/' + id, updateRecord),
            delete: async id => service.delete(url + id),
            toggleVisibility: async (id, isHidden) => service.post(url + "togglevisibility/" + id + "/" + isHidden),
        }
    }
}